import React, { Component, Fragment } from "react";
import { defaultStyles } from "./util/styles";
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
  Typography,
  withStyles,
  Link,
  Divider,
} from "@material-ui/core";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import "moment/locale/sl";
import "./util/material_phone_input.css";
import { KeyboardDatePicker } from "@material-ui/pickers";
import api from "./util/api";
import MessageOverlay from "./components/MessageOverlay";
import strings from "./strings";
import moment from "moment";
import { formatPrice } from "./util/helpers";
import SchoolAutocomplete from "./components/SchoolAutocomplete";
import { reCaptchaKey, termsUrl, privacyUrl } from "./util/constants";
import AddressAutocomplete from "./components/AddressAutocomplete";
import logoSVG from "./res/img/404-logo.svg";

const styles = (theme) => ({
  ...defaultStyles(theme),
  dateField: {
    margin: 0,
    width: "100%",
  },
});

const initialState = {
  data: null,
  error: false,
  reCaptchaKey: null,
  privacyPolicyChecked: false,
  paymentMethod: "",
  numberOfInstallments: 1,
  submitting: false,
  success: false,
  submitError: false,
};

class Home extends Component {
  state = initialState;

  componentDidMount() {
    this.getData();
  }

  resetState = () => {
    this.getData();
    this.setState(initialState);
    this.resetFieldsData();
  };

  getData = () => {
    const id = parseInt(this.props.match.params.id);

    api.get(
      `/sign_up/forms/${id}`,
      {},
      {
        onSuccess: (response) =>
          this.setState({
            error: false,
            data: response.data,
          }),
        onError: (reason) =>
          this.setState({
            error: true,
            data: null,
          }),
      }
    );
  };

  resetFieldsData = () => {
    const fields = { field_value_1823: "", field_value_1826: "" };
    this.setState({ ...fields });
  };

  getFieldsData = () => {
    const result = [];

    for (let fieldData of this.state.data.fields) {
      const id = fieldData.id;
      const type = fieldData.type;
      let value = this.state[`field_value_${fieldData.id}`];

      if (type === "int") value = parseInt(value);
      if (type === "float") value = parseFloat(value);
      if (type === "date") value = moment(value).format("YYYY-MM-DD");

      result.push({
        field_id: id,
        value: value,
      });
    }

    return result;
  };

  submit = () => {
    this.setState({ submitting: true });
    const fields = this.getFieldsData();

    api.post(
      `/sign_up/forms/${this.state.data.id}/submit`,
      {
        captcha: this.state.reCaptchaKey,
        payment_type: this.state.paymentMethod,
        number_of_installments: this.state.numberOfInstallments,
        fields: fields,
      },
      {
        onSuccess: (response) => this.setState({ success: true }),
        onError: (reason) => this.setState({ submitError: true }),
      }
    );
  };

  getTitle = () => {
    const { classes } = this.props;
    const { data } = this.state;

    return (
      <Grid container direction="row" justify="flex-start">
        <Grid item xs={12}>
          <Typography className={classes.subtitle}>
            {strings.signUpFor}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h4" className={classes.title}>
            {data.title}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  getPrice = () => {
    const { classes } = this.props;
    const { data } = this.state;

    return (
      <Grid
        container
        direction="row"
        justify="flex-start"
        spacing={1}
        alignItems="center"
      >
        {data.is_free ? (
          <Grid item>
            <Typography className={classes.priceTitle}>
              {strings.free}
            </Typography>
          </Grid>
        ) : (
          <Fragment>
            {data.price ? (
              <Fragment>
                <Grid item>
                  <Typography className={classes.priceTitle}>
                    {strings.price}:
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.price}>
                    {formatPrice(data.price.price)}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.priceName}>
                    ({data.price.name})
                  </Typography>
                </Grid>
              </Fragment>
            ) : (
              <Grid item>
                <Typography className={classes.price}>
                  {formatPrice(data.default_price)}
                </Typography>
              </Grid>
            )}
          </Fragment>
        )}
      </Grid>
    );
  };

  getNavigation = () => {
    return (
      <Box pt={5}>
        <Grid item xs={12} align="center">
          <Link href="https://404.si/">
            <img src={logoSVG} alt="404-logo" width={180} height={100} />
          </Link>
        </Grid>
      </Box>
    );
  };

  getFooter = () => {
    return (
      <Box align="center" pb={5} pt={3}>
        <Grid item xs={12} md={10} lg={8}>
          <img src={logoSVG} alt="404-logo" width={95} height={50} />
        </Grid>
        <Grid item xs={12}>
          <Typography>
            {strings.companyName}, {strings.companyAddress},{" "}
            {strings.companyCity}
          </Typography>
        </Grid>
        <Grid container direction="row" justify="center">
          <Link href="https://404.si/pogoji-poslovanja/">
            Pogoji poslovanja
          </Link>
          <Divider orientation="vertical" flexItem variant="middle" />
          <Link href="https://404.si/politika-zasebnosti/">
            Politika zasebnosti
          </Link>
        </Grid>
      </Box>
    );
  };

  onFieldChange = (fieldData, value) =>
    this.setState({
      [`field_value_${fieldData.id}`]: value,
    });

  getFieldValue = (fieldData, defaultValue) => {
    if (this.state[`field_value_${fieldData.id}`])
      return this.state[`field_value_${fieldData.id}`];
    return defaultValue;
  };

  getFieldComponent = (fieldData) => {
    const { classes } = this.props;
    switch (fieldData.type) {
      case "string":
        return (
          <TextField
            label={fieldData.name}
            value={this.getFieldValue(fieldData, "")}
            onChange={(e) => this.onFieldChange(fieldData, e.target.value)}
            variant="outlined"
            className={classes.w100}
            required={fieldData.required}
          />
        );
      case "int":
        return (
          <TextField
            label={fieldData.name}
            value={this.getFieldValue(fieldData, "")}
            onChange={(e) => this.onFieldChange(fieldData, e.target.value)}
            variant="outlined"
            className={classes.w100}
            required={fieldData.required}
            type="number"
            inputProps={{ step: 1 }}
          />
        );
      case "float":
        return (
          <TextField
            label={fieldData.name}
            value={this.getFieldValue(fieldData, "")}
            onChange={(e) => this.onFieldChange(fieldData, e.target.value)}
            variant="outlined"
            className={classes.w100}
            required={fieldData.required}
            type="number"
            inputProps={{ step: 0.01 }}
          />
        );
      case "bool":
        return (
          <FormControlLabel
            control={
              <Checkbox
                checked={this.getFieldValue(fieldData, false)}
                onChange={(e) =>
                  this.onFieldChange(fieldData, e.target.checked)
                }
                name={fieldData.name}
                required={fieldData.required}
              />
            }
            label={fieldData.name}
          />
        );
      case "email":
        return (
          <TextField
            label={fieldData.name}
            value={this.getFieldValue(fieldData, "")}
            onChange={(e) => this.onFieldChange(fieldData, e.target.value)}
            variant="outlined"
            type="email"
            className={classes.w100}
            required={fieldData.required}
          />
        );
      case "phone":
        // phone input label must be set via css which is unfortunate. inline styles don't work for :before elements
        return (
          <Fragment>
            <style>
              {`div.flag-dropdown:before {content: "${fieldData.name}" !important}`}
            </style>
            <PhoneInput
              country={"si"}
              value={this.getFieldValue(fieldData, "")}
              onChange={(phone) => this.onFieldChange(fieldData, phone)}
              inputProps={{ required: fieldData.required }}
            />
          </Fragment>
        );
      case "enum_radio":
        return (
          <Box pt={2}>
            <FormControl>
              <Box pb={1}>
                <FormLabel required={fieldData.required}>
                  {fieldData.name}
                </FormLabel>
              </Box>
              <RadioGroup
                name={fieldData.name}
                value={this.getFieldValue(fieldData, "")}
                onChange={(e) => this.onFieldChange(fieldData, e.target.value)}
              >
                {fieldData.options.map((option) => (
                  <FormControlLabel
                    value={option}
                    control={<Radio size="small" />}
                    label={option}
                    key={option}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
        );
      case "enum_dropdown":
        return (
          <FormControl className={classes.w100} variant="outlined">
            <InputLabel required={fieldData.required}>
              {fieldData.name}
            </InputLabel>
            <Select
              value={this.getFieldValue(fieldData, "")}
              label={fieldData.name}
              onChange={(e) => this.onFieldChange(fieldData, e.target.value)}
            >
              {fieldData.options.map((option) => (
                <MenuItem value={option} key={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      case "date":
        return (
          <KeyboardDatePicker
            margin="normal"
            className={classes.dateField}
            inputVariant="outlined"
            format="DD. MM. YYYY"
            label={fieldData.name}
            required={fieldData.required}
            locale="sl"
            ampm={false}
            cancelLabel={strings.cancel}
            clearLabel={strings.clear}
            okLabel={strings.ok}
            todayLabel={strings.today}
            value={this.getFieldValue(fieldData, null)}
            onChange={(value) => this.onFieldChange(fieldData, value)}
          />
        );
      case "school":
        return (
          <SchoolAutocomplete
            label={fieldData.name}
            required={fieldData.required}
            q
            onChange={(e) => this.onFieldChange(fieldData, e.target.value)}
            value={this.getFieldValue(fieldData, "")}
          />
        );
      case "address":
        return (
          <AddressAutocomplete
            label={fieldData.name}
            required={fieldData.required}
            onSelected={(address) => this.onFieldChange(fieldData, address)}
          />
        );
      default:
        return null;
    }
  };

  getField = (fieldData) => {
    return (
      <Grid item xs={12} md={10} lg={8} key={fieldData.id}>
        {this.getFieldComponent(fieldData)}
      </Grid>
    );
  };

  getPaymentMethodSelect = () => {
    const { data, paymentMethod } = this.state;
    const { classes } = this.props;

    if (data.is_free) return null;

    const numberOfInstallments = data.price
      ? data.price.max_number_of_installments
      : data.default_max_number_of_installments;

    return (
      <Grid item xs={12} md={10} lg={8} key="payment-select">
        <Grid container direction="row" spacing={2} alignItems="center">
          <Grid item xs={12} md={numberOfInstallments === 1 ? 12 : 6}>
            <FormControl className={classes.w100} variant="outlined">
              <InputLabel required>{strings.paymentMethod}</InputLabel>
              <Select
                value={paymentMethod}
                label={strings.paymentMethod}
                onChange={(e) =>
                  this.setState({ paymentMethod: e.target.value })
                }
              >
                <MenuItem value="trr" key="trr">
                  {strings.trr}
                </MenuItem>
                <MenuItem value="stripe" key="stripe">
                  {strings.cardPayment}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {numberOfInstallments === 1 ? null : (
            <Grid item xs={12} md={6}>
              <FormControl className={classes.w100} variant="outlined">
                <InputLabel required>{strings.numberOfInstallments}</InputLabel>
                <Select
                  value={this.state.numberOfInstallments}
                  label={strings.numberOfInstallments}
                  onChange={(e) =>
                    this.setState({ numberOfInstallments: e.target.value })
                  }
                >
                  {Array(numberOfInstallments)
                    .fill()
                    .map((_, i) => (
                      <MenuItem value={i + 1} key={i + 1}>
                        {i + 1}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  };

  getCaptcha = () => {
    return (
      <Grid item xs={12} md={10} lg={8} key="captcha">
        <Box pt={2}>
          <ReCAPTCHA
            sitekey={reCaptchaKey}
            onChange={(key) => this.setState({ reCaptchaKey: key })}
          />
        </Box>
      </Grid>
    );
  };

  getPrivacyPolicyCheck = () => {
    const { privacyPolicyChecked } = this.state;
    return (
      <Grid item xs={12} md={10} lg={8} key="terms-check">
        <FormControlLabel
          control={
            <Checkbox
              checked={privacyPolicyChecked}
              onChange={(e) =>
                this.setState({ privacyPolicyChecked: e.target.checked })
              }
              name="privacy policy"
              required
            />
          }
          label={
            <p>
              {strings.iAgreeWith}{" "}
              <a href={privacyUrl}>{strings.iAgreeWithPrivacyPolicy}</a>{" "}
              {strings.and} <a href={termsUrl}>{strings.iAgreeWithTerms}</a>.
            </p>
          }
        />
      </Grid>
    );
  };

  getFormValidationErrors = () => {
    const { data, privacyPolicyChecked, reCaptchaKey, paymentMethod } =
      this.state;
    const errors = [];

    const mailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    for (let field of data.fields) {
      if (field.required) {
        const v = this.state[`field_value_${field.id}`];
        if (v == null || v === "" || v === false)
          errors.push(strings.fieldIsRequired(field.name));
        else if (field.type === "email" && !mailRegex.test(v))
          errors.push(strings.fieldEmailRequired);
      }
    }

    if (!data.is_free && paymentMethod !== "trr" && paymentMethod !== "stripe")
      errors.push(strings.youHaveToChooseYourPaymentMethod);

    if (!privacyPolicyChecked)
      errors.push(strings.youHaveToAgreeWithPrivacyPolicy);

    if (reCaptchaKey == null) errors.push(strings.youHaveToPassRecaptcha);

    return errors;
  };

  getSubmitButton = () => {
    const errors = this.getFormValidationErrors();

    return (
      <Grid item xs={12} md={10} lg={8} key="submit">
        {errors.length === 0 ? (
          <Button
            color="primary"
            variant="contained"
            onClick={this.submit}
            key="button"
            disableElevation
          >
            <Box px={2}>{strings.submitApplication}</Box>
          </Button>
        ) : (
          <Tooltip
            title={
              <ul key="ul">
                {errors.map((err) => (
                  <li key={err}>{err}</li>
                ))}
              </ul>
            }
            key="tooltip"
          >
            <span>
              <Button
                color="primary"
                variant="contained"
                disabled
                disableElevation
              >
                <Box px={2}>{strings.submitApplication}</Box>
              </Button>
            </span>
          </Tooltip>
        )}
      </Grid>
    );
  };

  getDescription = () => {
    const { data } = this.state;
    if (!data.description) return null;

    return (
      <Grid item xs={12} md={10} lg={8}>
        <Box pt={2}>
          <Typography>{data.description}</Typography>
        </Box>
      </Grid>
    );
  };

  render() {
    const { error, data, success, submitError } = this.state;

    // loading and error
    if (error)
      return (
        <MessageOverlay
          title={strings["404"]}
          message={strings.couldNotLoadActivityData}
        />
      );
    if (data == null)
      return <MessageOverlay loading message={strings.loadingData} />;

    // sign up not active
    if (data.hidden)
      return (
        <MessageOverlay
          title={strings.signUpDisabled}
          message={strings.signUpDisabledDescription}
        />
      );

    if (!data.valid && moment().isBefore(moment(data.valid_from)))
      return (
        <MessageOverlay
          title={strings.signUpNotYetActive}
          message={`${strings.signUpNotYetActiveDescription} ${moment(
            data.valid_from
          ).format("D. M. YYYY, HH:mm")}.`}
        />
      );

    if (!data.valid)
      return (
        <MessageOverlay
          title={strings.signUpNotActiveAnymore}
          message={strings.signUpNotActiveAnymoreDescription}
        />
      );

    // submit error and success
    if (submitError) {
      return (
        <MessageOverlay
          title={strings.submitError}
          message={strings.submitErrorDescription}
          messageText={strings.submitErrorText}
          reset={this.resetState}
        />
      );
    }

    if (success) {
      return (
        <MessageOverlay
          title={strings.submitSuccess}
          message={strings.submitSuccessDescription}
          messageText={strings.submitSuccessText}
          reset={this.resetState}
          additionalButtonsTitle={strings.submitSuccessAdditionalButtonsTitle}
          additionalButtons={this.state.data.linked_activities.map((a) => (
            <Button
              color="secondary"
              variant="contained"
              key={a.form_id}
              disableElevation
              className={this.props.classes.w100}
              onClick={() => {
                // Router does not reload all necessary data
                window.location.href = `/aktivnost/${a.form_id}/`;
              }}
            >
              {a.note}
            </Button>
          ))}
        />
      );
    }

    const urlParams = new URLSearchParams(window.location.search);
    const logo = urlParams.get("logo");

    if (logo === "true") {
      return (
        <Container maxWidth="md">
          {this.getNavigation()}
          <Box py={5}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item xs={12} md={10} lg={8}>
                {this.getTitle()}
              </Grid>
              <Grid item xs={12} md={10} lg={8}>
                {this.getPrice()}
              </Grid>
              {this.getDescription()}
              <Grid item xs={12} />
              <Grid item xs={12} />
              <Grid item xs={12} />
              {data.fields.map(this.getField)}
              {this.getPaymentMethodSelect()}
              {this.getCaptcha()}
              {this.getPrivacyPolicyCheck()}
              {this.getSubmitButton()}
            </Grid>
          </Box>
          {this.getFooter()}
        </Container>
      );
    }

    return (
      <Container maxWidth="md">
        <Box py={5}>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12}>
              {this.getTitle()}
            </Grid>
            <Grid item xs={12}>
              {this.getPrice()}
            </Grid>
            {this.getDescription()}
            <Grid item xs={12} />
            <Grid item xs={12} />
            <Grid item xs={12} />
            {data.fields.map(this.getField)}
            {this.getPaymentMethodSelect()}
            {this.getCaptcha()}
            {this.getPrivacyPolicyCheck()}
            {this.getSubmitButton()}
          </Grid>
        </Box>
      </Container>
    );
  }
}

export default withStyles(styles)(Home);
